import { useEffect, useState } from 'react';
import { useRange, type UseRangeProps } from 'react-instantsearch';

import { Slider } from '~/components/OddscheckerPlus/components/cxy';

let timerId: NodeJS.Timeout;
let timeout = 200;

export const SliderFilter = ({
	isDisabled = false,
	label,
	step = 1,
	...props
}: UseRangeProps & { isDisabled?: boolean; label: string; step?: number }) => {
	const { canRefine, range, refine, start } = useRange(props);
	const min = range.min as number;
	const lowestValue = Number(start[0]);

	const [value, setValue] = useState(min);

	const from = Math.max(min, Number.isFinite(lowestValue) ? lowestValue : min);

	useEffect(() => {
		setValue(from);
	}, [from]);

	return (
		<Slider
			disabled={isDisabled || !canRefine}
			label={label}
			max={range.max}
			min={range.min}
			onValueChange={(values: number[]) => {
				setValue(values[0]);

				if (timerId) {
					clearTimeout(timerId);
				}

				timerId = setTimeout(() => {
					refine([values[0], range.max]);
				}, timeout);
			}}
			step={step}
			unit="%"
			value={[value]}
			{...props}
		>
			EV
		</Slider>
	);
};
